let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j5WDM")).then(() => parcelRequire('2wY3J'));